import React from 'react'

export default function IcoChevron( props ) {
  return (
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.2"
      viewBox="0 0 24 24"
      { ...props }
    >
      <path d="M6 9l6 6 6-6" />
    </svg>
  )
}
